/* Level 7: provider health status panel (split from CDMDocumentsSettings.jsx) */
import React from 'react';
import { RefreshCw } from 'lucide-react';
import { PIPELINE_API, authedFetch } from './api';

export function ProviderHealthPanel() {
  const [health, setHealth] = React.useState(null);
  const [checking, setChecking] = React.useState(false);

  const fetchHealth = async () => {
    try {
      const res = await authedFetch(`${PIPELINE_API}/api/system/health-status`);
      if (res.ok) setHealth(await res.json());
    } catch (e) { /* silent */ }
  };

  React.useEffect(() => { fetchHealth(); }, []);

  const handleRecheck = async () => {
    setChecking(true);
    await fetchHealth();
    setChecking(false);
  };

  if (!health || !health.services) return null;

  return (
    <div className="space-y-1.5 mt-3 pt-3 border-t border-gray-100" data-testid="provider-health-panel">
      <div className="flex items-center justify-between">
        <p className="text-[10px] font-medium text-gray-500">Service Health</p>
        <button
          onClick={handleRecheck}
          disabled={checking}
          className="flex items-center gap-1 text-[10px] text-cyan-600 hover:text-cyan-500 disabled:opacity-50"
          data-testid="recheck-all-btn"
        >
          <RefreshCw className={`h-3 w-3 ${checking ? 'animate-spin' : ''}`} />
          {checking ? 'Checking...' : 'Recheck All'}
        </button>
      </div>
      {health.services.map(s => (
        <div key={s.group} className="flex items-center gap-2 text-[10px]" data-testid={`provider-health-${s.group}`}>
          <span className={`w-2 h-2 rounded-full shrink-0 ${
            s.severity === 'error' ? 'bg-red-500' : s.severity === 'warning' ? 'bg-amber-400' : 'bg-green-500'
          }`} />
          <span className="text-gray-700 min-w-0 flex-1 truncate">{s.label}</span>
          <span className={`shrink-0 font-medium ${
            s.severity === 'error' ? 'text-red-600' : s.severity === 'warning' ? 'text-amber-600' : 'text-green-600'
          }`}>{s.state === 'closed' ? 'OK' : s.state === 'half_open' ? 'Recovering' : 'Down'}</span>
        </div>
      ))}
      {health.overall === 'healthy' && (
        <div className="flex items-center gap-1.5 text-[10px] text-green-600 pt-1">
          <span className="w-2 h-2 rounded-full bg-green-500" />
          All services healthy
        </div>
      )}
      {health.checked_at && (
        <p className="text-[9px] text-gray-400 pt-1">Last checked: {new Date(health.checked_at).toLocaleTimeString()}</p>
      )}
    </div>
  );
}
